/**
 * Copyright 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const getMessageFromErrorResponse = error =>
  error && error.errors ? error.errors.map(el => el.message) : ['Unknown network error'];

export const ERR_MSG_NOT_FOUND = 'Item was not found';
